/* ANOTION valid pack selection: keep Shopify variant IDs and native purchase flow. */
(function(){
  if(window.anotionMatchingPacksReady)return;window.anotionMatchingPacksReady=true;
  document.addEventListener('change',function(event){
    const input=event.target;
    if(!(input instanceof HTMLInputElement)||input.type!=='radio')return;
    const picker=input.closest('variant-radios');
    if(!picker||picker.dataset.url!=='/products/group-leakproof-bamboo-mason-jar-22-oz-mrj7hc9n-1')return;
    const groups=Array.from(picker.querySelectorAll('fieldset'));
    const changed=groups.indexOf(input.closest('fieldset'));if(changed<0)return;
    let variants;try{variants=JSON.parse(picker.querySelector('script[type="application/json"]').textContent);}catch{return;}
    const selected=groups.map(g=>g.querySelector('input:checked')?.value);
    if(variants.some(v=>v.options.every((o,i)=>o===selected[i])))return;
    const candidates=variants.filter(v=>v.options[changed]===input.value);
    const match=candidates.find(v=>v.available)||candidates[0];if(!match)return;
    groups.forEach((g,i)=>g.querySelectorAll('input[type="radio"]').forEach(r=>{r.checked=r.value===match.options[i];}));
  },true);
})();